import { FC } from "react"
import { BottomBarConfig } from "./BottomBarContext"
import MapFooter from "features/map/footer/MapFooter"
import { zIndex } from "@nova/constants"

interface BottomBarControllerProps {
    config: BottomBarConfig | undefined
}
const BottomBarController: FC<BottomBarControllerProps> = ({ config }) => {
    return (
        <div
            style={{
                zIndex: zIndex.Footer,
            }}
        >
            {config?.Item ? <config.Item /> : <MapFooter />}
        </div>
    )
}

export { BottomBarController }
